import {queryOptions} from '@tanstack/react-query'
import {notFound} from '@tanstack/react-router'
import {createServerFn} from '@tanstack/react-start'
import {z} from 'zod'
import fetchProductTypeImages from '~/client/sanity/fetchProductTypeImages'
import {applyServerFnCache} from '~/client/fn/utils'
import {Locale} from '~/gql/graphql'

const CACHE_TIME_SEC = 60 * 60 * 3 // 3h

const defaultImagesParams = z
    .object({
        locale: z.nativeEnum(Locale).optional(),
    })
    .optional()

const getDefaultImages = createServerFn({
    method: 'GET',
})
    .inputValidator((data: unknown) => {
        const result = defaultImagesParams.safeParse(data)
        if (result.error) {
            throw notFound()
        }
        return result.data
    })
    .handler(async ({data}) => {
        const {locale} = data ?? {}

        const images = await fetchProductTypeImages(locale)

        applyServerFnCache(CACHE_TIME_SEC)

        return images
    })

export const defaultImagesQueryOptions = (locale: Locale = Locale.EnEu) =>
    queryOptions({
        queryKey: [locale, 'images', 'default'],
        gcTime: CACHE_TIME_SEC * 1000, // 3h
        staleTime: CACHE_TIME_SEC * 1000, // 3h
        queryFn: () => getDefaultImages({data: {locale}}),
    })
